const state = {
  mode: null,
  customImage: null,
}

const getters = {}

const mutations = {
  setContentMode(state, payload) {
    state.mode = payload
  },
  setContentCustomImage(state, payload) {
    state.customImage = payload
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
